import { render, staticRenderFns } from "./FeatureTourSlide.vue?vue&type=template&id=ec8381dc&scoped=true"
import script from "./FeatureTourSlide.vue?vue&type=script&lang=js"
export * from "./FeatureTourSlide.vue?vue&type=script&lang=js"
import style0 from "./FeatureTourSlide.vue?vue&type=style&index=0&id=ec8381dc&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8381dc",
  null
  
)

export default component.exports